export default __webpack_public_path__ + "static/media/step2@2x.fb8a19ba.jpg";